import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const pageData: Record<string, {
  title: string;
  text: React.ReactNode;
  param: string;
}> = {
  '1': {
    title: 'Privacy Statement',
    param: 'privacy',
    text: <div className="space-y-3 text-sm text-slate-800 leading-relaxed" data-id="element-2672">
        <p className="text-red-600 font-semibold" data-id="element-2673">Privacy Statement</p>
        <p data-id="element-2674">
          By registering with Desert Sage Seminars, you will create an account
          by which we may provide you with quality on-line real estate license
          renewal classes. Your information will be kept confidential and not
          shared with any other party.
        </p>
        <p data-id="element-2675">
          The Arizona Department of Real Estate requires that we confirm your
          information and that you are the person taking the classes.
        </p>
        <p data-id="element-2676">
          Payments you make for our classes are made through a 3rd party
          merchant account secured by our site, and they do not share your
          credit card information with us or any other party.
        </p>
        <p data-id="element-2677">
          Any requests by an outside party for information about you or your
          account will be denied except for any request from the Arizona
          Department of Real Estate, or any other regulatory agency empowered to
          investigate your real estate activity.
        </p>
        <p data-id="element-2678">
          Any questions or concerns about our Privacy Policy should be sent to{' '}
          <a href="mailto:support@desertsageseminars.com" className="text-blue-600 hover:underline" data-id="element-2679">
            support@desertsageseminars.com
          </a>
        </p>
      </div>
  },
  '2': {
    title: 'About Us',
    param: 'about-us',
    text: <div className="text-sm text-slate-800 leading-relaxed" data-id="element-2680">
        <p className="text-red-600 font-semibold mb-2" data-id="element-2681">About Us</p>
        <p data-id="element-2682">Learn about our history and mission.</p>
      </div>
  },
  '3': {
    title: 'Terms of Service',
    param: 'terms',
    text: <div className="text-sm text-slate-800 leading-relaxed" data-id="element-2683">
        <p className="text-red-600 font-semibold mb-2" data-id="element-2684">Terms of Service</p>
        <p data-id="element-2685">Please read these terms carefully.</p>
      </div>
  }
};
export function ViewStaticPage() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const page = id && pageData[id] ? pageData[id] : pageData['1'];
  return <div className="space-y-4" data-id="element-2686">
      <div className="flex items-center justify-between" data-id="element-2687">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2688">Static Page</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/static-pages')} data-id="element-2689">
          ← Back to Static Pages
        </Button>
      </div>

      <Card data-id="element-2690">
        <CardContent className="pt-6" data-id="element-2691">
          <table className="text-sm w-full" data-id="element-2692">
            <tbody data-id="element-2693">
              <tr className="border-b border-slate-100" data-id="element-2694">
                <td className="py-2 pr-6 font-medium text-slate-700 w-20 align-top" data-id="element-2695">
                  Title
                </td>
                <td className="py-2 text-slate-900" data-id="element-2696">{page.title}</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2697">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2698">
                  Text
                </td>
                <td className="py-3 max-w-xl" data-id="element-2699">{page.text}</td>
              </tr>
              <tr data-id="element-2700">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2701">
                  Param
                </td>
                <td className="py-2 text-slate-900 font-mono text-xs" data-id="element-2702">
                  {page.param}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6" data-id="element-2703">
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate(`/static-pages/edit/${id}`)} data-id="element-2704">
              Edit Page
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}